export default __webpack_public_path__ + "static/media/wojak.7ce64cb9.png";